import React, { useEffect } from "react";
import "./Footer.css";// optional, or replace with → symbol
import { FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const Footer = () => {

    useEffect(() => {
    window.scrollTo(0, 0);
    }, []);

  return (
    <footer className="footer">
      {/* Top CTA Section */}
      <div className="footer-top">
        <div className="cta-box">
          <p className="small-text">Need Any Service?</p>
          <h2 className="cta-heading">
            We’re Ready to offer you <br /> excellent service.
          </h2>
          <Link to="/contact">
            <div className="contactBtn">
              <button className="contact-btn">
                  Contact us
              </button>
              <button className="contact-btn">
                  <FiArrowUpRight  size={24}/>
              </button>
          </div>
        </Link>
        </div>
      </div>

      <div className="footer_empty_div"></div>

      {/* Bottom Footer Section */}
      <div className="footer-bottom">
        <div className="footer-content">
          <div className="footer-column">
            <h4>Office</h4>
            <p>
              Km 16, Port Harcourt-Aba Expressway <br />
              Boskel Road, Port Harcourt, Nigeria
            </p>
          </div>

          <div className="footer-column">
            <h4>Contact info</h4>
            <p> <FaPhoneAlt /> +234 807 379 5573</p>
            <p> < FaEnvelope/> info@wellcleanoilfieldservices.com</p>
          </div>

          <div className="footer-column">
            <h4>Useful Links</h4>
            <p><Link to="/services">Services</Link></p>
            <p><Link to='/about'>About us</Link></p>
          </div>
        </div>
        <div className="footer-bottom-text">
          ©2022 WellClean Oilfield Services Ltd.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
